import dayjs from 'dayjs';

// Conteúdo fictício da pré-visualização: imagens mockup geradas em SVG (sem conteúdo real nem arquivos externos)

type MockVariant = 'banner' | 'news';

const PALETTES = [
    { sky: ['#4fc3f7', '#e1f5fe'], sun: '#fff59d', far: '#81c784', near: '#388e3c', city: '#546e7a' },
    { sky: ['#ff8a65', '#ffe0b2'], sun: '#fff176', far: '#a1887f', near: '#6d4c41', city: '#5d4037' },
    { sky: ['#7986cb', '#e8eaf6'], sun: '#ffffff', far: '#9fa8da', near: '#3949ab', city: '#283593' },
    { sky: ['#4db6ac', '#e0f2f1'], sun: '#fffde7', far: '#80cbc4', near: '#00796b', city: '#004d40' },
    { sky: ['#ba68c8', '#f3e5f5'], sun: '#ffecb3', far: '#ce93d8', near: '#7b1fa2', city: '#4a148c' },
    { sky: ['#64b5f6', '#fffde7'], sun: '#ffca28', far: '#aed581', near: '#689f38', city: '#455a64' },
];

function buildings(width: number, height: number, color: string, seed: number): string {
    const count = 9;
    const slot = width / count;
    let rects = '';
    for (let i = 0; i < count; i++) {
        const h = height * (0.18 + (((i * 7 + seed * 3) % 10) / 10) * 0.22);
        const w = slot * 0.62;
        rects += `<rect x="${(i * slot + slot * 0.19).toFixed(0)}" y="${(height * 0.78 - h).toFixed(0)}" width="${w.toFixed(0)}" height="${h.toFixed(0)}" rx="4" fill="${color}" opacity="0.55"/>`;
    }
    return rects;
}

export function mockImageDataUri(index: number, variant: MockVariant): string {
    const p = PALETTES[index % PALETTES.length];
    const [w, h] = variant === 'banner' ? [1600, 500] : [800, 450];
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" preserveAspectRatio="xMidYMid slice">
<defs><linearGradient id="s" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${p.sky[0]}"/><stop offset="1" stop-color="${p.sky[1]}"/></linearGradient></defs>
<rect width="${w}" height="${h}" fill="url(#s)"/>
<circle cx="${w * (0.2 + (index % 3) * 0.25)}" cy="${h * 0.3}" r="${h * 0.12}" fill="${p.sun}" opacity="0.9"/>
${buildings(w, h, p.city, index)}
<path d="M0 ${h * 0.72} Q ${w * 0.25} ${h * 0.55} ${w * 0.5} ${h * 0.7} T ${w} ${h * 0.66} V ${h} H 0 Z" fill="${p.far}"/>
<path d="M0 ${h * 0.86} Q ${w * 0.3} ${h * 0.72} ${w * 0.6} ${h * 0.84} T ${w} ${h * 0.8} V ${h} H 0 Z" fill="${p.near}"/>
</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export interface PreviewBannerSample {
    title: string;
    image: string;
}

export interface PreviewNewsSample {
    title: string;
    date: string;
    image: string;
}

export const PREVIEW_BANNERS: PreviewBannerSample[] = [
    { title: 'Título do banner de exemplo', image: mockImageDataUri(0, 'banner') },
    { title: 'Campanha institucional de exemplo', image: mockImageDataUri(3, 'banner') },
];

const NEWS_TITLES = [
    'Título de notícia de exemplo para a pré-visualização',
    'Prefeitura anuncia ação de exemplo para a comunidade',
    'Notícia de exemplo com um título um pouco mais longo para ver o corte',
    'Evento de exemplo reúne moradores no centro da cidade',
];

export const PREVIEW_NEWS: PreviewNewsSample[] = NEWS_TITLES.map((title, i) => ({
    title,
    date: dayjs().subtract(i * 3, 'day').format('YYYY-MM-DD'),
    image: mockImageDataUri(i + 1, 'news'),
}));

// Imagem mockup para itens cujo arquivo ainda não tem URL pública de pré-visualização
export const sampleImage = (index: number, variant: MockVariant = 'news') => mockImageDataUri(index, variant);
